import apiService from '../../../../service/apiService';
import * as UtilityFunctions from '../../../../HelperMethods/UtilityFunctions';

export const types = {
  ALL_ASSET_ATTRIBUTES_LOADED: 'ALL_ASSET_ATTRIBUTES_LOADED',
  ALL_ROUTES_LOADED: 'ALL_ROUTES_LOADED',
};

export function getAllAssetAttributes(objectType) {
  return (dispatch) => {
    const filter = { entityType: 'asset', objectType };
    return apiService.bulkDownloadEntityAttributes({ filter }).then((response) => {
      dispatch({ type: types.ALL_ASSET_ATTRIBUTES_LOADED, data: response });
    });
  };
}

export function getAllRoutesForFieldId(fieldId) {
  return (dispatch) => {
    return apiService
      .searchAssets(UtilityFunctions.createFilterObjForAllRoutesAndFieldId(fieldId), null, null, null)
      .then((response) => {
        dispatch({ type: types.ALL_ROUTES_LOADED, data: response.data.searchAssets.items });
      });
  };
}

export function showPreviewForCriteriaAndField(criteria, fieldId) {
  return () => {
    return apiService.getStopIdsPreviewForCriteria({ criteria, fieldId }).then((response) => {
      if (response.data.rpcService.success) {
        return response.data.rpcService.output;
      }
      throw new Error(response.data.rpcService.message);
    });
  };
}
